var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      staticClass: "full-screen-modal",
      attrs: {
        id: "annonce-success-modal",
        "hide-footer": "",
        "hide-header": "",
        centered: "",
        "ok-variant": "primary"
      }
    },
    [
      _c("div", [
        _c("div", { staticClass: "col-12 custom-col-12" }, [
          _c(
            "div",
            {
              staticClass: "custom-border-bottom",
              attrs: { id: "container-title-modal" }
            },
            [
              _c("span", { staticClass: "page-title" }, [
                _vm._v(_vm._s(_vm.$t("annonce.Declare.Success.Title")))
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("p", {
          staticClass: "modal-annonce-text mt-3 mb-3",
          attrs: { id: "custom-p-modal" },
          domProps: {
            innerHTML: _vm._s(_vm.$t("annonce.Declare.Success.Text"))
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-start col-12" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "d-flex align-items-start" }, [
              _c("i", {
                staticClass:
                  "ph-custom ph-check-circle main-color custom-size-icon mt-1"
              }),
              _vm._v(" "),
              _c("p", {
                staticClass: "modal-annonce-text ml-2",
                domProps: {
                  innerHTML: _vm._s(_vm.$t("annonce.Declare.Success.Check"))
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "d-flex align-items-start" }, [
              _c("i", {
                staticClass:
                  "ph-custom ph-x-circle main-red-color custom-size-icon mt-1"
              }),
              _vm._v(" "),
              _c("p", {
                staticClass: "modal-annonce-text ml-2",
                domProps: {
                  innerHTML: _vm._s(_vm.$t("annonce.Declare.Fail.X"))
                }
              })
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70a7181f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70a7181f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/annonce/AnnonceSuccessModalStep0.vue
// module id = aBwe
// module chunks = 0